module.exports = __webpack_public_path__ + "img/feeder_pillar.391f4f60.png";